export default __webpack_public_path__ + "static/media/error-page-image.18cfd468.png";